var map = {
	"./de.json": 2215,
	"./el.json": 2216,
	"./en.json": 2217,
	"./et.json": 2218,
	"./fil.json": 2219,
	"./gr.json": 2220,
	"./pl.json": 2221,
	"./ru.json": 2222,
	"./sv.json": 2223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2214;